/**
 * Created by Mohamed on 4/18/2016.
 */

var publicConfiguration;
var _;

if (typeof window !== 'undefined') {
    publicConfiguration = window.publicConfiguration;
    _ = window._;
}

if (typeof(publicConfiguration) === 'undefined') {
    // This nodejs
    publicConfiguration = {};

    try {
        publicConfiguration = require('./public.conf');
    }
    catch (e) {
        console.error("Failed to load configuration file");
    }
}

if (typeof(_) === 'undefined') {
    // This nodejs
    var _ = require("underscore");
}

var prepareDefaultHeadTags = function (title, description) {
    return [
        {
            "tag": "title",
            "attributes": {},
            "value": title
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": title
            }
        },
        {
            "tag": "meta",
            "attributes": {"name": "description", "content": description}
        },
        {
            "tag": "meta",
            "attributes": {"property": "og:description", "content": description}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {"property": "og:site_name", "content": "Harri"}
        }
    ];
};

publicConfiguration['routes'] = {
    "light-signup?code&redirect_url&brand": {
        "name": "homepage.lightSignUp",
        "type": "frontend",
        "reloadOnSearch": false,
        "showGlobalSearch": false,
        "modal": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "views": {
            "light-signup-view": {
                "templateUrl": "../modules/light_signup/views/light_sign_up.html"
            }
        },
        "onEnter": [function () {
        }],
        "onExit": [function () {
            $(".modal-backdrop").remove();
        }]
    },

    "/404": {
        "name": "404",
        "templateUrl": "../modules/404page/views/404.html",
        "type": "backend-frontend",
        "controller": "PageNotFoundController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["404_page"]
        },
        "route_dependencies": [
        {
            type: 'chunk',
            loader: function () {
                return import('../../hmodules/harri-main/harri-main.module.js');
            }
        }
    ]
    },

    "/redirectTo?link&response_type&source": {
        "name": "redirectTo",
        "type": "frontend",
        "onEnter": ['$stateParams', '$state', function ($stateParams, $state){
            var showErrorMsg = function () {
                hConfirm({
                    title: $filter("translate")("Error!"),
                    text: $filter("translate")("Something went wrong with previewing/downloading this document, please try again later"),
                    confirmButton: $filter('translate')('Okay'),
                    cancelButtonClass: 'hidden',
                    callback: function (confirmed) {
                        if (confirmed) {
                            window.close()
                        }
                    }
                });
            };
            var FILE_NAMES = {
                'team_info': 'Team Info.csv'
            };
            var DATA_TYPES = {
                'CSV' : 'text/csv',
                'JSON': 'application/json'
            };
            var api = window.BaseAPI();
            api.request(decodeURIComponent($stateParams.link), 'GET').then(function(resp){
                if(resp && resp.status === 200){
                    if($stateParams.response_type && $stateParams.source){
                        Utils.downloadFileWithBOM(resp.data, FILE_NAMES[$stateParams.source], DATA_TYPES[$stateParams.response_type]);
                        window.close();
                    }
                    else if(resp.data.status_code === 200){
                        window.location.href = resp.data.data.link;
                    }
                }else {
                    showErrorMsg();
                }
            }, function(err) {
                console.error(err);
                showErrorMsg();
                });
        }]
    },


    // Social referral, sms redirection
    "/social_referral/referrals/invite?token&job_id": {
        "name": "social-referral-invitation",
        "showGlobalSearch": false,
        "type": "frontend",
        "templateUrl": "../modules/social_referral/views/social_referral_invitation.html",
        "controller": 'SocialReferralInvitationController'
    },

    // Talent scout redirection to application
    "/talent-scout?brand_id&code_id": {
        "name": "talent-scout-redirection",
        "type": "frontend",
        "templateUrl": "../hmodules/talent-scout/containers/talent-scout-redirection/talent-scout-redirection.container.html",
        "controller": "TalentScoutRedirectionContainer",
        "loginRequired": false,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "onEnter": ['$state', '$stateParams', function ($state, $stateParams) {
            const brandId = $stateParams.brand_id;
            const codeId = $stateParams.code_id;
            if (brandId === '1503033' && codeId) {
                return true;
            } else if (brandId && codeId) {
                CoreReaderAPI.getTalentScoutRedirectionURL(brandId, codeId).then((res) => {
                    window.location = res.redirect_url;
                }).catch((err) => {
                    console.error(err)
                    $state.go("404");
                })
            } else {
                $state.go("404");
            }

        }],
    },

    //dynamic member routing config //consider the following as a template
    "/member%slug": {
        "enableUTM": true,
        "name": "candidate",
        "showGlobalSearch": true,
        "analytics_name": "profile.candidate",
        "templateUrl": "../modules/profiles/views/member.html",
        "type": "backend-frontend",
        "dynamic-template": "member",
        "controller": 'MemberProfilesController',
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": function () {
        },
        "onExit": ['$state', function ($state) {
            $.fancybox.close();
        }],
        "data": [
            {"type": "api", 'link': publicConfiguration.getBaseAPI('coreReaderAPIServers') +'profile/member/:id', 'id': 'memberData'},
            {
                "type": "api",
                'link': 'profile/media?type=member&item_id=:id&image_limit=6&video_limit=2',
                'id': 'memberMedia'
            },
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "{{data.user_info.first_name}} {{data.user_info.last_name}} | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "{{data.user_profile.bio | limitTo(170)}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:title",
                    "content": "{{data.user_info.first_name}} {{data.user_info.last_name}} | Harri"
                }
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "{{mediaServer}}users/{{data.user_info.id}}/user_profile/{{data.profile_image}}/640_640.jpeg"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "{{data.user_profile.bio | limitTo(170)}}"}
            },
        ],
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {
            // 766
            var mergedData = {};

            mergedData.data = data.memberData.data || {};
            publicFunctions.formatProfilesMedia(data.memberMedia.data.video_gallery);

            if (data.memberMedia.data.image_gallery) {
                for (var i = 0; i < data.memberMedia.data.image_gallery.length; i++) {
                    data.memberMedia.data.image_gallery[i].media_for = 'user_photo';
                }
            }

            if (mergedData.data.user_location) {
                // Get the primary location if available
                mergedData.data.primary_location = mergedData.data.user_location[0];

                for (var i in mergedData.data.user_location) {
                    if (mergedData.data.user_location[i].is_primary == true) {
                        mergedData.data.primary_location = mergedData.data.user_location[i];
                        break;
                    }
                }
            }

            mergedData.data.profile_media = data.memberMedia.data;
            mergedData.data.user_info.profile_image =  mergedData.data.profile_image;
            mergedData.data.media_slug = "candidate";

            publicConfiguration.publicData = publicConfiguration.publicData || {};
            publicConfiguration.publicData.userInfo = mergedData.data.user_info;

            if (typeof(getBaseURL) != 'undefined') {
                mergedData.baseURL = getBaseURL();
            }

            return mergedData;
        }
    },

    // This is being handled by the backend in a special way
    "/media/{img_id:.*}": {
        "name": "candidate.media",
        // This just to indicate a backend support, /media/ has a special handling in the backend that doesn't depend on this value
        // Meta tags for media are attached dynamically in the RouteRequest
        "type": "backend-frontend",
        "showGlobalSearch": true,
        "analytics_name": "candidate.media",
        "dynamic-template": "member",
        "disableAutoScroll": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                // data.media is only available for BOTs
                "value": "{% if data.media %}{{data.media.title}}{% else %}Gallery{% endif %} | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "{{data.media.description}}"}
            },
            {
                "tag": "meta",
                "attributes": {"name": "keywords", "content": "job,jobs"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "{{data.media.title}} | Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:image", "content": "{{data.media.thumb}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "{{data.media.description}}"}
            }
        ],
        views: {
            "media-viewer": {
                templateUrl: "../modules/media_viewer/views/viewer.html",
            }
        },
        "reloadOnSearch": true,
        "onEnter": ['$stateParams', function ($stateParams) {
//               $.fancybox.open('.media-img');
            //  $stateParams['img_id']
            if ($('.fancybox-overlay').length == 0) {
                // $.fancybox.open(['media-img']);
            }
        }],
        "onExit": ['$state', function ($state) {
            setTimeout(function () {
                if ($state.current.name.indexOf(".media") < 0) {
                    $.fancybox.close();
                }
            }, 100);
        }]
    },

    '/invite-to-apply': {
        'name': 'candidate.invite',
        'analytics_name': 'candidate.invite',
        "showGlobalSearch": false,
        'type': 'frontend',
        'dynamic-template': 'member',
        'views': {
            'invite-to-apply': {
                controller: 'MemberInviteToApplyController'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "reloadOnSearch": true,
        'onEnter': ['$state', function ($state) {

        }],
        'onExit': function () {
        },
        "loginRequired": true
    },
    '/join-and-connect': {
        'name': 'candidate.joinAndConnect',
        'analytics_name': 'candidate.join_and_connect',
        'type': 'frontend',
        'dynamic-template': 'member',
        'views': {
            'connect-modal': {
                templateUrl: "../modules/profiles/views/partials/connect.html"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "reloadOnSearch": true,
        'onEnter': ['$state', '$transitions', function ($state, $transitions) {
            $transitions.onSuccess({}, function() {
                $("#connect-modal .modal").modal('show');
                $("#connect-modal .modal").unbind('hidden.bs.modal').on('hidden.bs.modal', function () {
                    // go to main candidate profile.
                    $state.go('^');
                });
            });

        }],
        'onExit': function () {
            $('body').removeClass('modal-open');
        }
    },


    "/member%slug/portfolio": {
        "name": "portfolio",
        "analytics_name": "portfolio.candidate",
        "showGlobalSearch": true,
        "type": "backend-frontend",
        "templateUrl": "../modules/profiles/views/portfolio.html",
        "dynamic-template": "member",
        "data": [
            {"type": "api", 'link': publicConfiguration.getBaseAPI('coreReaderAPIServers') +'profile/member/:id', 'id': 'memberPortfolioData'},
            {"type": "api", 'link': 'profile/media?type=member&item_id=:id', 'id': 'media'}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['member_portfolio']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};

            var formattedMedia = publicFunctions.formatPortfolioMedia(data.media.data);

            mergedData.data = {
                media: formattedMedia,
                member: data.memberPortfolioData.data
            };

            if (mergedData.data.member.user_location) {
                // Get the primary location if available
                mergedData.data.member.primary_location = mergedData.data.member.user_location[0];

                for (var i in mergedData.data.member.user_location) {
                    if (mergedData.data.member.user_location[i].is_primary == true) {
                        mergedData.data.member.primary_location = mergedData.data.member.user_location[i];
                        break;
                    }
                }
            }

            return mergedData;

        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "{{ data.member.user_info.first_name }} {{ data.member.user_info.last_name }} Portfolio | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "{{data.member.user_profile.bio | limitTo(170)}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:title",
                    "content": "{{ data.member.user_info.first_name }} {{ data.member.user_info.last_name }} Portfolio | Harri"
                }
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "{{mediaServer}}users/{{data.member.user_info.id}}/user_profile/{{data.member.profile_image}}/640_640.jpeg"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:description",
                    "content": "{{data.member.user_profile.bio | limitTo(170)}}"
                }
            }
        ]
    },

    "media section in portfolio": {
        "url": "/media/:img_id",
        "name": "portfolio.media",
        "analytics_name": "portfolio.media",
        "type": "frontend",
        "showGlobalSearch": false,
        "dynamic-template": "member",
        "disableAutoScroll": true,
        views: {
            "media-viewer": {
                templateUrl: "../modules/media_viewer/views/viewer.html",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['member_portfolio']
        },
        onEnter: function () {
        },
        "onExit": ['$state', function ($state) {
            setTimeout(function () {
                if ($state.current.name.indexOf(".media") < 0) {
                    $.fancybox.close();
                }
            }, 100);
        }]
        // "reloadOnSearch":true
    },

    "/search-group": {
        "name": "appLayout.harriSH.search",
        "type": "backend-frontend",
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "templateUrl": "../modules/search/views/search.html",
        "controller": 'searchFiltersController',
        "botsTemplateUrl": "../modules/search/views/bots-search.html",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Search | HARRI"
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "Search | HARRI"}
            }
        ],
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {
            return data;
        }
    },

    "^/jobs{filters:.*}": {
        "enableUTM": true,
        "name": "appLayout.harriSH.search.jobs",
        "params": {
            filters: {
                value: "",
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "views": {
            "searchpage": {
                templateUrl: "../modules/search/views/search-results.html"
            }
        },
        "onEnter": ['$state', 'hUser', function($state, hUser) {
            hUser.init().then(function () {
                if(hUser.isEmployer()) {
                    if (hUser.isTopLevelContext()) {
                        Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                    } else {
                        $state.go("appLayout.harriSH.dashboard");
                    }
                }
            });
        }]
    },
    "^/{test:[Hh][Uu][Jj]}obsUkrainianRefugees{filters:.*}": {
        "enableUTM": true,
        "name": "appLayout.harriSH.search.apprentice-jobs",
        "params": {
            filters: {
                value: "",
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "views": {
            "searchpage": {
                templateUrl: "../modules/search/views/search-results.html"
            }
        },
        "onEnter": ['$state', 'hUser', function($state, hUser) {
            hUser.init().then(function () {
                if(hUser.isEmployer()) {
                    if (hUser.isTopLevelContext()) {
                        Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                    } else {
                        $state.go("appLayout.harriSH.dashboard");
                    }
                }
            });
        }]
    },
    "^/companies{filters:.*}": {
        "enableUTM": true,
        "name": "appLayout.harriSH.search.companies",
        "params": {
            filters: {
                value: "",
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "views": {
            "searchpage": {
                templateUrl: "../modules/search/views/search-results.html"
            }
        },
        "onEnter": ['$state', 'hUser', function($state, hUser) {
            hUser.init().then(function () {
                if(hUser.isEmployer()) {
                    if (hUser.isTopLevelContext()) {
                        Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                    } else {
                        $state.go("appLayout.harriSH.dashboard");
                    }
                }
            });
        }]
    },
    "^/people{filters:.*}": {
        "enableUTM": true,
        "name": "appLayout.harriSH.search.people",
        "params": {
            filters: {
                value: "",
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "loginRequired": true,
        "views": {
            "searchpage": {
                templateUrl: "../modules/search/views/search-results.html"
            }
        },
        "requiredServiceCheck": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/talent-pool/talent-pool.module.js");
                }
            },
        ],
        "onEnter": ['$state', 'hUser', 'brandServices', 'userPermissions', 'hmapService', 'talentPoolDataService', function ($state, hUser, brandServices, userPermissions, hmapService, talentPoolDataService) {
            hUser.init().then(function () {
                if (hUser.isEmployer()) {
                    var brandId = hmapService.getActiveBrand();
                    if (hUser.isTopLevelContext()) {
                        brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, brandId)
                            .then(function (res) {
                                if (res) {
                                    if (hUser.isLoggedIn()) {
                                        userPermissions.getBrandPolicy(brandId)
                                            .then(function (policyParser) {
                                                var hasManageTalentPoolPermission = policyParser.brands(brandId).has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE);
                                                if (!hasManageTalentPoolPermission) {
                                                    Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                                                }
                                            });
                                    }
                                } else {
                                    Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                                }
                            }, function (err) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            });
                    } else {
                        talentPoolDataService.checkTalentPoolPermissionOnEnterpriseAndChild()
                            .then(function (res) {
                                if (!res) {
                                    $state.go("appLayout.harriSH.dashboard");
                                }
                            });
                    }
                }
            });
        }],
        "onExit": function () {
            /* close Profile FancyBox if it's displayed */
            $.fancybox.close();
        }
    },
    "^/search{filters:.*}": {
        "enableUTM": true,
        "name": "appLayout.harriSH.search.all",
        "params": {
            filters: {
                value: "",
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "requiredServiceCheck": true,
        "views": {
            "searchpage": {
                templateUrl: "../modules/search/views/search-results.html"
            }
        },
        "onEnter": ['$state', 'hUser', function($state, hUser) {
            hUser.init().then(function () {
                if(hUser.isEmployer()) {
                    if (hUser.isTopLevelContext()) {
                        Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                    } else {
                        $state.go("appLayout.harriSH.dashboard");
                    }
                }
            });
        }],
        "onExit": function () {
            /* close Profile FancyBox if it's displayed */
            $.fancybox.close();
        }
    },
    "^/shortlist": {
        "name": "appLayout.harriSH.search.shortlist",
        "showGlobalSearch": true,
        "views": {
            "searchpage": {
                "templateUrl": "../modules/search/views/shortlist.html",
                //"controller" : "ShortlistController",
                //"controllerAs" : "Shortlist"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": ['$state', 'hUser', 'brandServices', 'userPermissions', 'hmapService', 'talentPoolDataService', function($state, hUser, brandServices, userPermissions, hmapService, talentPoolDataService) {
            if (!hUser.isEmployer()) {
                $state.go("appLayout.harriSH.dashboard");
            } else {
                var brandId = hmapService.getActiveBrand();
                if (hUser.isTopLevelContext()) {
                    brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, brandId)
                        .then(function (res) {
                            if (res) {
                                userPermissions.getBrandPolicy(brandId)
                                    .then(function (policyParser) {
                                        var hasManageTalentPoolPermission = policyParser.brands(brandId).has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE);
                                        if (!hasManageTalentPoolPermission) {
                                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                                        }
                                    });
                            } else {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            }
                        }, function (err) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        });
                } else {
                    talentPoolDataService.checkTalentPoolPermissionOnEnterpriseAndChild()
                        .then(function (res) {
                            if (!res) {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        });
                }
            }
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/talent-pool/talent-pool.module.js");
                }
            },
        ],
        "onExit": function () {
            $('#speedy-screen-modal').modal('hide');

            /* close Profile FancyBox if it's displayed */
            $.fancybox.close();
        },
        "loginRequired": true
    },

    "/marketing/brand/:brandId": {
        "enableUTM": true,
        "name": "brand-marketing",
        "templateUrl": "../modules/profiles/views/marketing-brand.html",
        "type": "backend-frontend",
        "controller": 'ClaimProfileController',
        "data": [
            {"type": "api", 'link': publicConfiguration["OMISServerBaseURL"] + '/brand/:brandId', 'id': 'brandDetails'}
        ],
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};
            var position = "";
            if (data.brandDetails.status_code != 200) {
                hRedirect('/404');
                return {};
            }

            mergedData.data = data.brandDetails.data;

            var brandMedia = data.brandDetails.data.BrandMedia;

            if (brandMedia) {

                var profile_photo = _.findWhere(brandMedia, {'type': 'profile_image'});
                var background_photo = _.findWhere(brandMedia, {'type': 'background_image'});


                if (profile_photo) {
                    mergedData.data.profile_media = profile_photo;
                }

                if (background_photo) {
                    mergedData.data.cover_media = background_photo;
                }

                var gallery = _.where(brandMedia, {'type': "gallery_image"});
                if (gallery && gallery.length) {
                    mergedData.data.profile_media.image_gallery = gallery;
                }
            }

            if (data.brandDetails.data.Jobs && data.brandDetails.data.Jobs.length) {
                for (var i = 0; i < data.brandDetails.data.Jobs.length; i++) {
                    var job = data.brandDetails.data.Jobs[i].Job;

                    if (job.Position && job.Position[0]) {
                        position = job.alias_position != undefined ? job.alias_position : job.Position[0].name;
                        mergedData.data.Jobs[i].Job.id = job.id;
                        mergedData.data.Jobs[i].Job.position = position;
                    }
                }
            }

            mergedData.data.media_slug = "employer";

            if (data.brandDetails.data.Location && data.brandDetails.data.Location.length) {
                mergedData.data.BrandLocations = publicFunctions.locationFormatter(data.brandDetails.data.Location);
            }

            mergedData.data.mediaServer = publicConfiguration.getMediaServer();
            return mergedData;
        },
        "onEnter": ['$state', '$stateParams', 'hUser', 'ClaimProfileAPI', function ($state, $stateParams, hUser, ClaimProfileAPI) {

            if (hUser.isLoggedIn()) {
                ClaimProfileAPI.notifyOMISAboutLoggedInUser($stateParams.brandId);
                $state.go('appLayout.harriSH.dashboard');
            }


            ClaimProfileAPI.notifyOMISAboutViewBrand($stateParams.brandId);

        }]
    },

    "/oauth/radisson?code&state&redirect_uri&error&error_description": {
        "name": "sso_radisson",
        "type": "frontend",
        "templateUrl": "../modules/sso/sso_redirect/sso-redirect-radisson.html",
        "controller": "SSORedirectController",
        "controllerAs": "ssoRedirectController",
        "route_styles": {
            framework: "bootstrap_v4"
        }
    },
    "/oauth/hallandwoodhouse?code&state&redirect_uri&error&error_description": {
        "name": "sso_hallandwoodhouse",
        "type": "frontend",
        "templateUrl": "../modules/sso/sso_redirect/sso-redirect-radisson.html",
        "controller": "SSORedirectController",
        "controllerAs": "ssoRedirectController",
        "route_styles": {
            framework: "bootstrap_v4"
        }
    },
     "/oauth/connectivity_source?code&state&redirect_uri&error&error_description": {
        "name": "sso_connectivity_source",
        "type": "frontend",
        "templateUrl": "../modules/sso/sso_redirect/sso-redirect-radisson.html",
        "controller": "SSORedirectController",
        "controllerAs": "ssoRedirectController",
        "route_styles": {
            framework: "bootstrap_v4"
        }
    },
    "/oauth/jackinthebox?code&state&redirect_uri&error&error_description": {
        "name": "sso_jib",
        "type": "frontend",
        "templateUrl": "../modules/sso/sso_redirect/sso-redirect-radisson.html",
        "controller": "SSORedirectController",
        "controllerAs": "ssoRedirectController",
        "route_styles": {
            framework: "bootstrap_v4"
        }
    },
    "/oauth/subway?code&state&redirect_uri&error&error_description": {
        "name": "sso_subway",
        "type": "frontend",
        "templateUrl": "../modules/sso/sso_redirect/sso-redirect-radisson.html",
        "controller": "SSORedirectController",
        "controllerAs": "ssoRedirectController",
        "route_styles": {
            framework: "bootstrap_v4"
        }
    },
    "/radisson_login": {
        "name": "sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-radisson.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/districttaco_login": {
        "name": "district_taco_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-district-taco.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/freebirds_login": {
        "name": "free_birds_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-free-birds.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/hallandwoodhouse_login": {
        "name": "hw_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-hall-and-woodhouse.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/fullers_login": {
        "name": "fuller_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-fullers.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/arcburger_login": {
        "name": "arc_burger_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-arc-burger.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/mcd_login": {
        "name": "mcd_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-mcd.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/Fulhamshores_login": {
        "name": "fulham_shores_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-fulham-shores.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/shakeshack_login": {
        "name": "shakeshack_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-shack-shake.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/steaknshake_login": {
        "name": "steaknshake_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-steak-and-shake.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/kfc_login": {
        "name": "kfc_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-kfc.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/firmdale_login": {
        "name": "firmdale_hotels_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-firmdale-hotels.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/connectivity_source_login": {
        "name": "connectivity_source_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-connectivity-source.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/jackinthebox_login": {
        "name": "jib_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-jib.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/mcdonaldsuk_login": {
        "name": "mcd_uk_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-mcd-uk.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },
    "/subway_login": {
        "name": "subway_sso_login",
        "type": "backend-frontend",
        "templateUrl": "../modules/sso/sso_login/sso-login-subway.html",
        "controller": "SSOLoginController",
        "controllerAs": "ssoLoginController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["sso_login"]
        }
    },

    //brands member routing config //consider the following as a template
    "/brand%slug": {
        "enableUTM": true,
        "showGlobalSearch": false,
        "customQueryURL": 'brand_view&filters&brand_id&group_id&job_alert&talent_scout_code_id',
        "name": "employer",
        "analytics_name": "profile.brand",
        "reloadOnSearch": false,
        "type": "backend-frontend",
        "dynamic-template": "brand",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['gp_career_portal', 'chat_bot']
        },
        "controllers": {
            "brand": {
                "templateUrl": "../modules/profiles/views/brand.html",
                "controller": "MemberProfilesController",
                "data": [
                    {
                        "type": "api",
                        'link': publicConfiguration.getBaseAPI('coreReaderAPIServers') +'profile/brand/:id',
                        'version': 'v1',
                        'id': 'brandDetails',
                        'method': 'GET',
                        'prepareLinkParams': function (route) {
                            if (route && route.isPrivateLink) {
                                return '?job_type=PRIVATE';
                            }

                            return '';
                        }
                    },
                    {
                        "type": "api",
                        'link': 'profile/media?type=brand&item_id=:id&image_offset=0&video_offset=0',
                        'id': 'brandMedia'
                    }
                ]
            },
            "gpCareerPortal": {
                "templateUrl": "../modules/profiles/views/gp-career-portal.html",
                "controller": "GPCareerPortalController",
                "data": [
                    {
                        "type": "api",
                        'link': 'career_portal/brands/:id/basic_info',
                        'version':'v2',
                        'id': 'basicInfo',
                        'method': 'GET',
                        'prepareLinkParams': function (route) {
                            if (route && route.isPrivateLink) {
                                return '?career_portal_type=PRIVATE';
                            }

                            return '';
                        }
                    },
                    {
                        "type": "api",
                        'link': 'career_portal/brands/:id/tree',
                        'id': 'enterpriseChildrenDetails',
                        'method': 'GET',
                        'prepareLinkParams': function (route) {
                            if (route && route.isPrivateLink) {
                                return '?career_portal_type=PRIVATE';
                            }

                            return '';
                        }
                    },
                    {
                        "type": "api",
                        'link': 'harri_search/search_jobs',
                        'id': 'jobSearchResult',
                        'method': 'post',
                        'nodejs_only': true,
                        'prepareBody': function (parameters) {

                            var availability = [];
                            var filterObj = {};
                            var filters = decodeURIComponent(parameters.filters);

                            if (filters && filters.length > 0) {
                                filters = filters.split('&');
                                for (var filterIndex in filters) {
                                    var filter =  filters[filterIndex].split('=');
                                    filterObj[filter[0]] = filter[1];
                                }

                                if (filterObj.jobsAvailability && filterObj.jobsAvailability.length > 0) {
                                    availability = filterObj.jobsAvailability.split(',');
                                }
                            }

                            var body = {
                                "search_phrase": filterObj['jobsPhrase'] || "",
                                "size": 15,
                                "radius": 100,
                                "start": 0,
                                "hecs": [],
                                "positions": (filterObj['jobsPosition']) ? [filterObj['jobsPosition']] : [],
                                "availability": availability,
                                "cuisines": [],
                                "skills": [],
                                "degrees": [],
                                'categories': (filterObj['jobsCategory']) ? [filterObj['jobsCategory']] : [],
                                "sort": [
                                    "publish_date"
                                ],
                                "sort_type": "desc",
                                "source": "web"
                            };

                            body.brand_level_id = (parameters.subId) ? parameters.subId : parameters.id;
                            return body;
                        }
                    }
                ]
            }
        },
        "onExit": function () {
            window.brandName = null;
            delete window.brandName;
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "{{data.name}} Jobs & Careers | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "Looking for your next opportunity? Search for vacancies at {{data.name}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "{{data.name}} Jobs & Careers | Harri"}
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "{{data.brand_image_path}}"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "Looking for your next opportunity? Search for vacancies at {{data.name}}"}
            },
            {
                "tag": "link",
                "attributes": {"rel": "canonical", "href": "{{request.host}}/{% if data.slug %}{{data.slug}}{% else %}{{basicInfo.slug}}{% endif %}"}
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
        "dataMappingDependencies": ["CareerPortalDataBus", "BrandProfileDataBus"],
        "dataMappingCallback": function (data, routeOptions, publicFunctions, CareerPortalDataBus, BrandProfileDataBus) {
            var mergedData = {};

            if (data.basicInfo) {
                //career portal

                mergedData.basicInfo = data.basicInfo.data;
                mergedData.media = {};

                if (mergedData.basicInfo.media) {
                    for (var i = 0; i < mergedData.basicInfo.media.length; i++) {
                        if (mergedData.basicInfo.media[i].type === 'career_portal_image') {
                            mergedData.basicInfo.career_portal_image = mergedData.basicInfo.media[i];
                            if (mergedData.basicInfo.career_portal_image.format === 'VIDEO') {
                                mergedData.basicInfo.career_portal_image.primaryMedia = mergedData.basicInfo.career_portal_image.media_secondary[0];
                            } else if (mergedData.basicInfo.career_portal_image.format === 'IMAGE') {
                                mergedData.basicInfo.career_portal_image.primaryMedia = mergedData.basicInfo.career_portal_image;
                            } else if (mergedData.basicInfo.career_portal_image.format === 'CAROUSEL') {
                                mergedData.basicInfo.career_portal_image.primaryMedia = mergedData.basicInfo.career_portal_image.media_secondary[0];
                            }
                        } else if (mergedData.basicInfo.media[i].type === 'career_portal_simple_view_image') {
                            mergedData.basicInfo.career_portal_simple_view_image = mergedData.basicInfo.media[i];
                            if (mergedData.basicInfo.career_portal_simple_view_image.format === 'VIDEO') {
                                mergedData.basicInfo.career_portal_simple_view_image.primaryMedia = mergedData.basicInfo.career_portal_simple_view_image.media_secondary[0];
                            } else if (mergedData.basicInfo.career_portal_simple_view_image.format === 'IMAGE') {
                                mergedData.basicInfo.career_portal_simple_view_image.primaryMedia = mergedData.basicInfo.career_portal_simple_view_image;
                            } else if (mergedData.basicInfo.career_portal_simple_view_image.format === 'CAROUSEL') {
                                mergedData.basicInfo.career_portal_simple_view_image.primaryMedia = mergedData.basicInfo.career_portal_simple_view_image.media_secondary[0];
                            }
                        } else if (mergedData.basicInfo.media[i].type === 'background_image') {
                            mergedData.basicInfo.background_image = mergedData.basicInfo.media[i];
                            if (mergedData.basicInfo.background_image.format === 'VIDEO') {
                                mergedData.basicInfo.background_image.primaryMedia = mergedData.basicInfo.background_image.media_secondary[0];
                            } else if (mergedData.basicInfo.background_image.format === 'IMAGE') {
                                mergedData.basicInfo.background_image.primaryMedia = mergedData.basicInfo.background_image;
                            } else if (mergedData.basicInfo.background_image.format === 'CAROUSEL') {
                                mergedData.basicInfo.background_image.primaryMedia = mergedData.basicInfo.background_image.media_secondary[0];
                            }
                        }
                        else if (mergedData.basicInfo.media[i].type === 'profile_image') {
                            mergedData.basicInfo.profile_image = mergedData.basicInfo.media[i];
                        }
                    }
                }

                mergedData.isPrivateLink = data.basicInfo.data.isPrivateLink;
                mergedData.basicInfo.isTenantJobEnabled = data.basicInfo.data.public_services?.indexOf('TENANT_JOBS') > -1;
                mergedData.isPrivateCareerPortalEnabled = data.basicInfo.data.isPrivateCareerPortalEnabled;

                var socialLinksCount = 0;

                if (mergedData.basicInfo.facebook_url) {
                    socialLinksCount++;
                }

                if (mergedData.basicInfo.instagram_url) {
                    socialLinksCount++;
                }

                if (mergedData.basicInfo.url) {
                    socialLinksCount++;
                }

                if (mergedData.basicInfo.twitter_url) {
                    socialLinksCount++;
                }

                if (mergedData.basicInfo.linkedin_url) {
                    socialLinksCount++;
                }

                if (mergedData.basicInfo.tiktok_url) {
                    socialLinksCount++;
                }

                mergedData.basicInfo.social_links_count = socialLinksCount;

                if (typeof(window) != "undefined") {
                    window.brandName = mergedData.basicInfo.name;
                }

                mergedData.enterpriseChildrenDetails = data.enterpriseChildrenDetails.data;

                if (mergedData.enterpriseChildrenDetails.type === 'ENTERPRISE') {
                    var totalDifference = 0;

                    for (var i in mergedData.enterpriseChildrenDetails.brands){
                        totalDifference += mergedData.enterpriseChildrenDetails.brands[i].active_jobs_count;
                    }

                    mergedData.enterpriseChildrenDetails.parentActiveJobsCount = mergedData.enterpriseChildrenDetails.active_jobs_count - totalDifference;
                }

                var brandsTree = {};
                brandsTree[mergedData.basicInfo.id] = mergedData.enterpriseChildrenDetails;
                mergedData.loading = true;

                if (typeof(CareerPortalDataBus) != 'undefined') {
                    CareerPortalDataBus.setBrandsTree(brandsTree);
                    CareerPortalDataBus.setBasicInfo(mergedData.basicInfo);
                    CareerPortalDataBus.setBrandLevelId(mergedData.basicInfo.id);
                }

                for (var i in mergedData.enterpriseChildrenDetails) {
                    if (mergedData.enterpriseChildrenDetails[i] && mergedData.enterpriseChildrenDetails[i].BrandMedia) {
                        mergedData.enterpriseChildrenDetails[i].brandMedia = {};
                        for (var j in mergedData.enterpriseChildrenDetails[i].BrandMedia) {
                            var media = mergedData.enterpriseChildrenDetails[i].BrandMedia[j];
                            mergedData.enterpriseChildrenDetails[i].brandMedia[media.type] = media;
                        }
                        delete(mergedData.enterpriseChildrenDetails[i].BrandMedia);
                    }
                }

                mergedData['data'] = mergedData['data'] || {};
                mergedData['data']['id'] = mergedData.basicInfo['id'];
                mergedData['data']['background_image'] = mergedData.basicInfo['background_image'] && mergedData.basicInfo['background_image']['primaryMedia'];
                mergedData['data']['profile_image'] = mergedData.basicInfo['profile_image'];

            } else {
                //normal brand
                var position = "";

                mergedData.data = data.brandDetails.data;
                mergedData.isPrivateLink = data.brandDetails.data.isPrivateLink;
                mergedData.isPrivateCareerPortalEnabled = data.brandDetails.data.isPrivateCareerPortalEnabled;


                if (mergedData.data.BrandMedia) {
                    for (var i = 0; i < mergedData.data.BrandMedia.length; i++) {
                        if (mergedData.data.BrandMedia[i].type === 'profile_image') {
                            mergedData.data.profile_image = mergedData.data.BrandMedia[i];
                        } else if (mergedData.data.BrandMedia[i].type === 'background_image') {
                            mergedData.data.background_image = mergedData.data.BrandMedia[i];
                            if (mergedData.data.background_image.format === 'VIDEO') {
                                mergedData.data.background_image.primary_media = mergedData.data.background_image.media_secondary[0];
                            } else if (mergedData.data.background_image.format === 'IMAGE') {
                                mergedData.data.background_image.primary_media = mergedData.data.background_image;
                            } else if (mergedData.data.background_image.format === 'CAROUSEL') {
                                mergedData.data.background_image.primary_media = mergedData.data.background_image.media_secondary[0];
                            }
                        }
                    }
                }

                if (data.brandMedia.data.video_gallery) {
                    for (var i = 0; i < data.brandMedia.data.video_gallery.length; i++) {
                        data.brandMedia.data.video_gallery[i].media_type = publicFunctions.videoType(data.brandMedia.data.video_gallery[i].path, data.brandMedia.data.video_gallery[i].is_hosted);
                    }
                }

                if (data.brandMedia.data.image_gallery) {
                    for (var i = 0; i < data.brandMedia.data.image_gallery.length; i++) {
                        data.brandMedia.data.image_gallery[i].media_for = 'brand_file';
                    }
                }
                mergedData.data.profile_media = data.brandMedia.data;

                if (data.brandDetails.data.Jobs && data.brandDetails.data.Jobs.length) {
                    for (var i = 0; i < data.brandDetails.data.Jobs.length; i++) {
                        position = data.brandDetails.data.Jobs[i].Job.alias_position != undefined ? data.brandDetails.data.Jobs[i].Job.alias_position : data.brandDetails.data.Jobs[i].Job.Position[0].name;
                        mergedData.data.Jobs[i].Job.id = data.brandDetails.data.Jobs[i].Job.id;
                        mergedData.data.Jobs[i].Job.position = position;
                    }
                }

                var socialLinksCount = 0;

                if (mergedData.data.facebook_url) {
                    socialLinksCount++;
                }
                if (mergedData.data.instagram_url) {
                    socialLinksCount++;
                }

                if (mergedData.data.url) {
                    socialLinksCount++;
                }
                if (mergedData.data.twitter_url) {
                    socialLinksCount++;
                }
                if (mergedData.data.tiktok_url) {
                    socialLinksCount++;
                }
                mergedData.data.social_links_count = socialLinksCount;

                mergedData.data.media_slug = "employer";

                // window obj is undefined in the backend
                // TODO: Try to remove brandName from window obj
                if (typeof(window) != "undefined") {
                    window.brandName = mergedData.data.name;

                    var brand_view = getParameterByName("brand_view");
                    if (brand_view) {
                        mergedData.data.brand_view = true;
                    }
                }

                if (data.brandDetails.data.Location && data.brandDetails.data.Location.length) {
                    mergedData.data.BrandLocations = publicFunctions.locationFormatter(data.brandDetails.data.Location);
                }
                if (typeof(BrandProfileDataBus) != 'undefined') {
                    BrandProfileDataBus.setData(mergedData.data);
                }
            }

            if (mergedData.basicInfo) {
                mergedData.basicInfo.isAccessibilityToolServiceEnabled = (mergedData.basicInfo.public_services && mergedData.basicInfo.public_services.indexOf('ACCESSIBILITY_TOOL') > -1);
            }

            return mergedData;
        }

    },
    "careerPortalJobApply": {
        "url": '/apply/:job_id?code&talent_scout_code_id',
        "name": "employer.apply",
        "params": {code: ""},
        "showGlobalSearch": false,
        "type": "frontend",
        "analytics_name": "career_portal.job.apply",
        "dynamic-template": "brand",
        "enableUsernameReferral": true,
        "enableUTM": true,
        "modal": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["gp_career_portal", "chat_bot", "registration"]
        },
        "views": {
            "job-apply": {
                "templateUrl": "../modules/job_apply/views/job_apply.html",
                "controller": "JobApplyController"
            }
        },
        "onExit": function () {
            $(".modal-backdrop").remove();
            HStorageManager.remove({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'placeholder_token'
            });
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
    },

    // This is being handled by the backend in a special way
    "/media/{img_id:.+}": {
        "name": "employer.media",
        "analytics_name": "employer.media",
        "type": "frontend",
        "disableAutoScroll": true,
        "dynamic-template": "brand",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        // This just to indicate a backend support, /media/ has a special handling in the backend that doesn't depend on this value
        // Meta tags for media are attached dynamically in the RouteRequest
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                // data.media is only available for BOTs
                "value": "{% if data.media %}{{data.media.title}}{% else %}Gallery{% endif %} | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "{{data.media.description}}"}
            },
            {
                "tag": "meta",
                "attributes": {"name": "keywords", "content": "job,jobs"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "{{data.media.title}} | Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:image", "content": "{{data.media.thumb}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "{{data.media.description}}"}
            }
        ],
        views: {
            "media-viewer": {
                templateUrl: "../modules/media_viewer/views/viewer.html",
            }
        },
        "onExit": ['$state', function ($state) {
            setTimeout(function () {
                if ($state.current.name.indexOf(".media") < 0) {
                    $.fancybox.close();
                }
            }, 100);
        }],
        "reloadOnSearch": true
    },
    "/brand%slug/job/{jobid:[0-9]+}-:title?redirect&view_only&h_apply_flow&first_name&last_name&talent_scout_code_id": {
        "enableUTM": true,
        "showGlobalSearch": false,
        "name": "job-post",
        "analytics_name": "JPLP",
        "type": "backend-frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['chat_bot']
        },
        "controller": "jobProfileController",
        "reloadOnSearch": false,
        "templateUrl": "../modules/job_profile/views/job-details.tmpl.html",
        "data": [
            {
                "type": "api",
                'link': publicConfiguration.getBaseAPI('coreReaderAPIServers') +'profile/job/:jobid',
                'id': 'jobData',
                'version': 'v1',
                'prepareLinkParams': function (route) {
                    if (route && route.isPrivateViaLinkJob && route.privateJobKey) {
                        return '?pjt=' + route.privateJobKey;
                    }
                    return '';
                }
            },
            {
                "type": "api",
                'link': 'career_portal/brands/:id/basic_info',
                'version':'v2',
                'id': 'basicInfo',
                'method': 'GET',
                'prepareLinkParams': function (route) {
                    if (route && route.isPrivateLink) {
                        return '?career_portal_type=PRIVATE';
                    }

                    return '';
                }
            }
        ],
        "dynamic-template": "brand",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "{%if data.job.alias_position %}{{data.job.alias_position}}{%else%}{{data.job.Position.name}}{%endif%} at {% if data.brand.external_business_name %}{{data.brand.external_business_name}}{% else %}{{data.brand.name}}{% endif %} | Harri Jobs"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "{{data.job.description | striptags | limitTo(150, '...') }}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:title",
                    "content": "{%if data.job.alias_position %}{{data.job.alias_position}}{%else%}{{data.job.Position.name}}{%endif%} at {% if data.brand.external_business_name %}{{data.brand.external_business_name}}{% else %}{{data.brand.name}}{% endif %} | {%if data.brand.is_privacy_shield%}{% if data.brand.external_business_name %}{{data.brand.external_business_name}}{% else %}{{data.brand.name}}{% endif %}{%else%}Harri{%endif%} Jobs"
                }
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {"property": "og:image", "content": "{{data.brand_image_path}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "{{data.job.description | striptags | limitTo(150, '...')}}"}
            },
            {
                "tag": "link",
                "attributes": {"rel": "canonical", "href": "{{request.host}}/{%if data.job.alias_position %}{{data.brand.slug | jobUrl(data.job.id, data.job.alias_position )}}{% else%}{{data.brand.slug | jobUrl(data.job.id, data.job.Position.name )}}{% endif %}"}
            }
        ],
        "dataMappingDependencies": ["JobDetailsBus", "$window"],
        "onExit": function () {
            $.fancybox.close();
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
        "dataMappingCallback": function (data, routeOptions, publicFunctions, JobDetailsBus, $window) {

            var mergedData = {};
            var position = "";

            var jobData = (data.jobData && data.jobData.data) || {};
            var brand = jobData.brand || {};
            var job = jobData.job || {};
            var topParentBrand = jobData['top_parent_brand'] || {};

            if (data.jobData && data.jobData.data) {
                if (([4246740, 4241280, 4239538].indexOf(topParentBrand['id']) === -1) && data.jobData.data.isPrivateCareerPortalEnabled && !data.jobData.data.job.applied_date) {
                    if (
                        (!data.jobData.data.isPrivateLink && ['PRIVATE_VIA_LINK','PUBLIC', 'BOTH'].indexOf(data.jobData.data.job.access_mode) === -1) ||
                        (data.jobData.data.isPrivateLink && ['PRIVATE', 'BOTH'].indexOf(data.jobData.data.job.access_mode) === -1)
                    ) {
                        hRedirect('/404');
                    }
                }

                mergedData.data = data.jobData.data;
            } else {
                // added by @shox if job data not exists
                hRedirect('/404');
            }

            if (job.id) {
                window.job_brand = {};
                window.job_brand[job.id] = brand.id;
            }

            if (brand.BrandMedia) {
                for (var i in brand.BrandMedia) {
                    if (brand.BrandMedia[i].type === 'job_background_image') {
                        brand.job_cover = brand.BrandMedia[i];
                    }

                    if (brand.BrandMedia[i].type === 'background_image') {
                        brand.background_image = brand.BrandMedia[i];
                        brand.cover_uuid = brand.BrandMedia[i].uuid;
                    }

                    if (brand.BrandMedia[i].type === 'profile_image') {
                        brand.profile_image = brand.BrandMedia[i];
                    }
                }
            }

            if (brand.force_media) {
                brand.forced_media = {};

                for (var i in brand.force_media) {
                    brand.force_media[i].path = brand.force_media[i].path || "";
                    brand.force_media[i].brand_id = brand.force_media[i].path.split("/")[1];
                    brand.forced_media[brand.force_media[i].type] = brand.force_media[i];
                }

                if(brand.forced_media['job_background_image']){
                    brand.job_cover = brand.forced_media['job_background_image'];
                }
            }

            if (brand.Location && brand.Location.length) {
                mergedData.data.brand.BrandLocations = publicFunctions.locationFormatter(brand.Location);
            }


            if (brand.slug && job.Position) {
                position = job.alias_position != undefined ? job.alias_position : job.Position.name;
                mergedData.data.job.id = job.id;
                mergedData.data.job.position = position;
            }

            /* Get Visibily options for JPLP
             // from util.js
             ==============================================*/

            if (data.basicInfo) {
                mergedData.data.basicInfo = data.basicInfo.data;
            }
            mergedData.data.visibility = getVisibilityForJPLP();

            mergedData.data.logjam_settings = brand.logjam_settings || {};
            /* Get Parameter
             ==========================*/
            // getParameterByName is not defined on Node.js side, only meanful in frontend
            if (typeof(getParameterByName) !== "undefined") {
                var utm_source = getParameterByName("utm_source");
                mergedData.data.utm_source = utm_source.toLowerCase();
                if (mergedData.data.utm_source == "simply") {
                    mergedData.data.utm_source = "simplyhired";
                }
                var viewOnly = getParameterByName('view_only');
                var h_apply_flow = getParameterByName('h_apply_flow');
                mergedData.data.viewOnly = viewOnly && (viewOnly.toLowerCase() === 'true');
                mergedData.data.h_apply_flow = h_apply_flow && (h_apply_flow.toLowerCase() === 'true');
            }

            if ($window.location.pathname.indexOf("/internal") === 0) {
                if (['PRIVATE', 'BOTH'].indexOf(job.access_mode) > -1) {
                    job.description = job.private_description || job.description;
                }
            }

            if (mergedData.data.brand && mergedData.data.brand.Location) {
                var locations = mergedData.data.brand.Location;

                for (var i in locations) {
                    var country = locations[i].Country || {};

                    if (country['code'] == 'UK') {
                        mergedData.data.currentCounrty = 'UK';
                    }
                }
            }

            if (mergedData.data.job.end_date) {
                mergedData.data.job.end_date = moment(mergedData.data.job.end_date).format('ddd, DD MMM YYYY');
            }

            if (data.jobData?.data?.isPrivateViaLinkJob && data.jobData?.data?.privateJobKey) {
                mergedData.data.job.private_via_link_settings = {
                    private_key: data.jobData.data.privateJobKey
                }
            }

            if (mergedData.data.job.estimated_start_date) {
                mergedData.data.job.estimated_start_date = moment(mergedData.data.job.estimated_start_date).format('ddd, DD MMM YYYY');
            }

            mergedData.data.tenantJobsServiceEnabled = (mergedData.data.brand.public_services && mergedData.data.brand.public_services.indexOf('TENANT_JOBS') > -1);


            let brandName = ''
            if (mergedData.data.brand.external_business_name) {
                brandName = mergedData.data.brand.external_business_name
            } else {
                brandName = mergedData.data.brand.name
            }

            let multipleLocationTooltip = '';
            for (let location of mergedData.data.job.JobLocation) {
                multipleLocationTooltip += brandName + '<br>';
            }

            mergedData.data.job.multipleLocationTooltip = multipleLocationTooltip;

            JobDetailsBus.setJobDetails(mergedData.data.job.id, {
                basicInfo: mergedData.data.basicInfo,
                job: mergedData.data.job,
                brand: mergedData.data.brand,
                top_parent_brand: mergedData.data.top_parent_brand
            });

            return mergedData;
        }
    },

    "/brand%slug/preview-job": {
        "enableUTM": true,
        "showGlobalSearch": false,
        "name": "preview-job-post",
        "analytics_name": "JPLP",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['chat_bot']
        },
        "controller": "previewJobProfileController",
        "reloadOnSearch": false,
        "templateUrl": "../modules/job_profile/views/preview-job-post.html",
        "dynamic-template": "brand",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/harri-main/harri-main.module.js');
                }
            }
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Preview: {% if data.job.alias_position %} {{ data.job.alias_position }} {% else %} {{ data.job.Position.name }} {% endif %} &nbsp at {% if data.brand.external_business_name %} {{ data.brand.external_business_name }} {% else %} {{ data.brand.name }} {% endif %}"
            }
        ]
    },
    "/careers/brand%slug?talent_scout_code_id": {
        "enableUTM": true,
        "showGlobalSearch": false,
        "dynamic-template": "brand",
        "name": "career-portal-story",
        "reloadOnSearch": false,
        "type": "backend-frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['career_portal_story']
        },
        "controllers": {
            "CareerStoryPageContainer": {
                "templateUrl": "../hmodules/career-story-page/containers/career-portal-story/career-story-page.container.html",
                "controller": "CareerStoryPageContainer",
                "data": [
                    {
                        "type": "api",
                        'link': '/public/brands/:id/career_story_pages',
                        'version':'v1',
                        'id': 'careerStoryPagesDetails',
                        'method': 'GET',
                    },
                    {
                        "type": "api",
                        'link': 'career_portal/brands/:id/basic_info',
                        'version':'v2',
                        'id': 'basicInfo',
                        'method': 'GET',
                        'prepareLinkParams': function (route) {
                            if (route?.isPrivateLink) {
                                return '?career_portal_type=PRIVATE';
                            }

                            return '';
                        }
                    },
                ]
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "{{data.name}} Jobs & Careers | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "Looking for your next opportunity? Search for vacancies at {{data.name}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "{{data.name}} Jobs & Careers | Harri"}
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "{{data.brand_image_path}}"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "Looking for your next opportunity? Search for vacancies at {{data.name}}"}
            }
        ],
        "dataMappingDependencies": ['careerStoryPageService', 'CareerPortalDataBus'],
        "dataMappingCallback": function (data, routeOptions, publicFunctions, careerStoryPageService, CareerPortalDataBus) {
            let mergedData = {};
            mergedData.basicInfo = data.basicInfo.data;
            if (typeof (CareerPortalDataBus) != 'undefined') {
                CareerPortalDataBus.setBasicInfo(mergedData.basicInfo);
            }
            let careerStoryPageData = data.careerStoryPagesDetails.data.career_story_page;
            if (!Object.keys(careerStoryPageData).length) {
                hRedirect('/404');
            }
            careerStoryPageService.setCareerStoryPageData(careerStoryPageData);
            mergedData.careerStoryPagesDetails = careerStoryPageService.getCareerStoryPageData();
            mergedData.MIDDLE_SECTION_TYPES = careerStoryPageService.MiddleSectionTypes;
            mergedData.currentYear = new Date().getFullYear();
            return mergedData;
        }
    },

    "/careers/brand%slug/preview?storyId": {
        "enableUTM": true,
        "showGlobalSearch": false,
        "dynamic-template": "brand",
        "name": "career-portal-story-preview",
        "reloadOnSearch": false,
        "type": "backend-frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['career_portal_story']
        },
        "controllers": {
            "CareerStoryPageContainer": {
                "templateUrl": "../hmodules/career-story-page/containers/career-portal-story/career-story-page.container.html",
                "controller": "CareerStoryPageContainer",
                "data": [
                    {
                        "type": "api",
                        'link': 'brands/:id/career_story_pages/preview_content/:storyId',
                        'version':'v1',
                        'id': 'previewContent',
                        'method': 'GET',
                    },
                    {
                        "type": "api",
                        'link': 'career_portal/brands/:id/basic_info',
                        'version':'v2',
                        'id': 'basicInfo',
                        'method': 'GET',
                        'prepareLinkParams': function (route) {
                            if (route?.isPrivateLink) {
                                return '?career_portal_type=PRIVATE';
                            }

                            return '';
                        }
                    },
                ]
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "{{data.name}} Jobs & Careers | Harri"
            },
            {
                "tag": "meta",
                "attributes": {"name": "description", "content": "Looking for your next opportunity? Search for vacancies at {{data.name}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "{{data.name}} Jobs & Careers | Harri"}
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "{{data.brand_image_path}}"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:description", "content": "Looking for your next opportunity? Search for vacancies at {{data.name}}"}
            }
        ],
        "dataMappingDependencies": ['$stateParams', 'careerStoryPageService', 'CareerPortalDataBus'],
        "dataMappingCallback": function (data, routeOptions, publicFunctions, $stateParams, careerStoryPageService, CareerPortalDataBus) {
            let mergedData = {};
            mergedData.basicInfo = data.basicInfo.data;
            if (typeof (CareerPortalDataBus) != 'undefined') {
                CareerPortalDataBus.setBasicInfo(mergedData.basicInfo);
            }
            let storyId = parseInt($stateParams['storyId']);
            let savedCareerStoryPageData = storyId ? data.previewContent.data: {};
            if (!storyId || !savedCareerStoryPageData?.found) {
                hRedirect('/404');
            }
            let careerStoryPageData = data.previewContent.data?.found ? data.previewContent.data.content : {};
            careerStoryPageData.source = 'PREVIEW';
            careerStoryPageService.setCareerStoryPageData(careerStoryPageData);
            mergedData.careerStoryPagesDetails = careerStoryPageService.getCareerStoryPageData();
            mergedData.MIDDLE_SECTION_TYPES = careerStoryPageService.MiddleSectionTypes;
            mergedData.currentYear = new Date().getFullYear();
            return mergedData;
        }
    },
    "careerStoryTalentPoolApply": {
        "url": '/apply/:job_id?talent_scout_code_id',
        "showGlobalSearch": false,
        "dynamic": true,
        "dynamic-template": "brand",
        "name": "career-portal-story.apply",
        "reloadOnSearch": false,
        "modal": true,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['career_portal_story', "chat_bot", "registration"]
        },
        "views": {
            "job-apply": {
                "templateUrl": "../modules/job_apply/views/job_apply.html",
                "controller": "JobApplyController"
            }
        },
        "onExit": function () {
            $(".modal-backdrop").remove();
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
    },
    "/apply/:job_id": {
        "name": "job-post.apply",
        "showGlobalSearch": false,
        "analytics_name": "job.apply",
        "type": "frontend",
        "dynamic": true,
        "customQueryURL": 'code&email&showLogin&msg',
        "dynamic-template": "brand",
        "modal": true,
        "enableUsernameReferral": true,
        "reloadOnSearch": false,
        "url": "/apply/:job_id",
        "onEnter": ['$stateParams','$state','$location', function ($stateParams,$state,$location) {
            if ($stateParams.code) {
                Utils.redirectToWorkspace('reset-password', {code: $stateParams.code , email:$stateParams.email, returnUrl: $location.$$url});
            }

        }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['chat_bot']
        },
        "views": {
            "job-apply": {
                "templateUrl": "../modules/job_apply/views/job_apply.html",
                "controller": "JobApplyController"
            }
        },
        "onExit": function () {
            $(".modal-backdrop").remove();
            HStorageManager.remove({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'placeholder_token'
            });
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
    },

    "/ats/{url:.*}": {
        "showGlobalSearch": false,
        "name": "ats",
        "params": {url: ""},
        "type": "frontend",
        "templateUrl": "../modules/job_profile/views/ats.html",
        "controller": "AtsController",

    },

    "/job_alert/subscription?token": {
        "enableUTM": true,
        "name": "job_alert_subscription",
        "type": "frontend",
        "reloadOnSearch": false,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "templateUrl": "../modules/job_alerts/subscription/job-alert-subscription.html",
        "controller": 'JobAlertSubscriptionController',
        "resolve": {
        }
    },

    "/job_alert/preferences?token&unsubscribe": {
        "enableUTM": true,
        "name": "job_alert_preferences",
        "reloadOnSearch": false,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "templateUrl": "../modules/job_alerts/preferences/job-alert-preferences.html",
        "controller": 'JobAlertPreferencesController',
        "resolve": {
        }
    },

    "/training-terms": {
        "name": "training-terms",
        "type": "backend-frontend",
        "templateUrl": "../modules/pages/views/training-terms.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};

            var mobile_app_redirect = false;

            // getParameterByName is not defined on Node.js side, only meanful in frontend
            if (typeof(getParameterByName) !== "undefined") {
                mobile_app_redirect = getParameterByName("mobile_app_redirect");
            }

            mergedData.mobile_app_redirect = mobile_app_redirect;
            return mergedData;
        }
    },
    "/legal/terms": {
        "name": "legal-terms",
        "showGlobalSearch": false,
        "type": "backend-frontend",
        "templateUrl": "../modules/pages/views/terms-of-services.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            return {};
        }
    },

    "/fpn": {
        "name": "fpn",
        "type": "backend-frontend",
        "showGlobalSearch": false,
        "templateUrl": "../modules/pages/views/privacy-and-fpn.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};

            var mobile_app_redirect = false;

            // getParameterByName is not defined on Node.js side, only meanful in frontend
            if (typeof(getParameterByName) !== "undefined") {
                mobile_app_redirect = getParameterByName("mobile_app_redirect");
            }

            mergedData.mobile_app_redirect = mobile_app_redirect;
            return mergedData;
        }
    },

    "/legal/privacy": {
        "name": "legal-privacy",
        "type": "backend-frontend",
        "showGlobalSearch": false,
        "templateUrl": "../modules/pages/views/privacy-and-fpn.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            return {};
        }
    },

    "/legal/msa": {
        "name": "msa",
        "type": "backend-frontend",
        "showGlobalSearch": false,
        "templateUrl": "../modules/pages/views/msa.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};

            var mobile_app_redirect = false;

            // getParameterByName is not defined on Node.js side, only meanful in frontend
            if (typeof(getParameterByName) !== "undefined") {
                mobile_app_redirect = getParameterByName("mobile_app_redirect");
            }

            mergedData.mobile_app_redirect = mobile_app_redirect;
            return mergedData;
        }
    },

    "/legal/reseller-msa": {
        "name": "reseller-msa",
        "type": "backend-frontend",
        "showGlobalSearch": false,
        "templateUrl": "../modules/pages/views/reseller-msa.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};

            var mobile_app_redirect = false;

            // getParameterByName is not defined on Node.js side, only meanful in frontend
            if (typeof(getParameterByName) !== "undefined") {
                mobile_app_redirect = getParameterByName("mobile_app_redirect");
            }

            mergedData.mobile_app_redirect = mobile_app_redirect;
            return mergedData;
        }
    },

    "/legal/sla": {
        "name": "sla",
        "type": "backend-frontend",
        "showGlobalSearch": false,
        "templateUrl": "../modules/pages/views/sla.html",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['h_pages']
        },
        "dataMappingCallback": function (data, routeOptions, publicFunctions) {

            var mergedData = {};

            var mobile_app_redirect = false;

            // getParameterByName is not defined on Node.js side, only meanful in frontend
            if (typeof(getParameterByName) !== "undefined") {
                mobile_app_redirect = getParameterByName("mobile_app_redirect");
            }

            mergedData.mobile_app_redirect = mobile_app_redirect;
            return mergedData;
        }
    },
    "/messages{params:.*}": {
        "name": "appLayout.harriSH.messages",
        "type": "frontend",
        "params": {
            params: {
                value: "",
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "templateUrl": "../modules/chat/views/cand_msgs.html",
        "controller": "candMsgsController",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Messages"
            }
        ],
        "loginRequired": true,
        "reloadOnSearch": false
    },
    "/get-candidate-mobile-app": {
        "name": "get-candidate-mobile-app",
        "type": "frontend",
        "templateUrl": "../modules/get_mobile_app/views/get-candidate-mobile-app.html",
        "onEnter": ['deviceChecker', '$timeout', function (deviceChecker, $timeout) {

            // initial var iOS
            var app_link = 'http://itunes.apple.com/app/id' + publicConfiguration['mobileAppData']['candidate']['ios_app_id'];

            // Android
            if (deviceChecker.Android()) {
                app_link = 'https://play.google.com/store/apps/details?id=' + publicConfiguration['mobileAppData']['candidate']['android_app_id'];
            }

            hRedirect(app_link);
        }],
    },
    "/get-teamlive-mobile-app": {
        "name": "get-teamlive-mobile-app",
        "type": "frontend",
        "templateUrl": "../modules/get_mobile_app/views/get-candidate-mobile-app.html",
        "onEnter": ['deviceChecker', function (deviceChecker) {

            // initial var iOS
            var app_link = 'http://itunes.apple.com/app/id' + publicConfiguration['mobileAppData']['teamlive']['ios_app_id'];

            // Android
            if (deviceChecker.Android()) {
                app_link = 'https://play.google.com/store/apps/details?id=' + publicConfiguration['mobileAppData']['teamlive']['android_app_id'];
            }

            hRedirect(app_link);
        }]
    },

    "/get-employer-mobile-app": {
        "name": "get-employer-mobile-app",
        "type": "frontend",
        "showGlobalSearch": true,
        "templateUrl": "../modules/get_mobile_app/views/get-candidate-mobile-app.html",
        "onEnter": ['deviceChecker', '$timeout', function (deviceChecker, $timeout) {

            // initial var iOS
            var app_link = 'https://itunes.apple.com/app/id' + publicConfiguration['mobileAppData']['employer']['ios_app_id'];

            // Android
            if (deviceChecker.Android()) {
                app_link = 'https://play.google.com/store/apps/details?id=' + publicConfiguration['mobileAppData']['employer']['android_app_id'];
            }

            hRedirect(app_link);
        }],
    },

    "/interview/:application_id?interview_type": {
        "enableUTM": true,
        "name": "interview",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "templateUrl": "../modules/interview/views/interview.html",
        "controller": "InterviewController",
        "data": [],
        "resolve": {
            digitalApp: ['$state', '$stateParams', '$q', function ($state, $stateParams, $q) {
                var defer = $q.defer();
                var applicationId = $stateParams.application_id;

                UserApplicationsAPI.loadAppDetails(applicationId)
                    .then(function (res) {
                        if (res.status_code == 200) {
                            defer.resolve(res);
                        }
                        else {
                            $state.go("404");
                        }
                    });

                return defer.promise;
            }]
        }
    },
    "/interview/:application_id/reschedule?interview_type": {
        enableUTM: true,
        name: "interviewReschedule",
        type: "frontend",
        loginRequired: true,
        showGlobalSearch: true,
        route_styles: {
            framework: "bootstrap_v4",
        },
        templateUrl: "../modules/interview/views/interview.html",
        controller: "InterviewController",
        data: [],
        resolve: {
            digitalApp: [
                '$state', '$stateParams', async ($state, $stateParams) => {
                    try {
                        const res = await UserApplicationsAPI.loadAppDetails($stateParams.application_id);
                        if (res.status_code === 200) {
                            return res;
                        } else {
                            $state.go("404");
                        }
                    } catch (error) {
                        console.error("Error loading digitalApp resolve:", error);
                        $state.go("404");
                    }
                }
            ]
        }
    },
    "/interview-availability": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-availability",
        "type": "frontend",
        "templateUrl": "../modules/interview-v2/interview-availability/root.html",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_availability"]
        },
        onEnter: ['$state', 'hUser', 'brandServices', function ($state, hUser, brandServices) {
            brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getUserContext().brand_id)
                .then(function (isOnBoardingJourneyEnabled) {
                    if (isOnBoardingJourneyEnabled) {
                        if(isOnBoardingJourneyEnabled || !hUser.isInterviewV2ServiceEnabled()) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });

        }]
    },
    "/training?brand_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "abstract": true,
        "name": "appLayout.harriSH.training",
        "type": "frontend",
        "templateUrl": "../modules/training/views/training.html",
        onEnter: ['$state', 'hUser', '$stateParams', function ($state, hUser, $stateParams) {
            if (hUser.isTopLevelContext() && !$stateParams.brand_id) {
                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
            }
        }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["e_verify_training"]
        }
    },
    "/e-verify/index": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.training.e-verify_training_index",
        "type": "frontend",
        onEnter: ['$state', 'hUser', '$stateParams', 'brandServices', function ($state, hUser, $stateParams, brandServices) {
            const { brand_id } = $stateParams;

            if (hUser.isTopLevelContext() && !brand_id) {
                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
            }

            const isEVerifyServiceEnabled = brand_id ?
                brandServices.check(brandServices.SERVICES.E_VERIFY, brand_id, true) :
                hUser.isEVerifyServiceEnabled();

            if (!isEVerifyServiceEnabled) {
                $state.go("appLayout.harriSH.dashboard");
            }
        }],
        "views": {
            "training": {
                templateUrl: "../modules/training/e-verify/views/e_verify_training_index.html",
                controller: "EVerifyTrainingController",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["e_verify_training"]
        }
    },
    "/e-verify": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.training.e-verify_training",
        "type": "frontend",
        "params" : {
            "hash": ""
        },
        onEnter: ['$state', 'hUser', '$stateParams', 'brandServices', function ($state, hUser, $stateParams, brandServices) {
            const { brand_id } = $stateParams;

            if (hUser.isTopLevelContext() && !brand_id) {
                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
            }

            const isEVerifyServiceEnabled = brand_id ?
                brandServices.check(brandServices.SERVICES.E_VERIFY, brand_id, true) :
                hUser.isEVerifyServiceEnabled();

            if (!isEVerifyServiceEnabled) {
                $state.go("appLayout.harriSH.dashboard");
            }
        }],
        "views": {
            "training": {
                templateUrl: "../modules/training/e-verify/views/e_verify_training.html",
                controller: "EVerifyTrainingController",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["e_verify_training"]
        }
    },
    "/e-verify/test": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.training.e-verify_test",
        "type": "frontend",
        onEnter: ['$state', 'hUser', '$stateParams', 'brandServices', function ($state, hUser, $stateParams, brandServices) {
            const { brand_id } = $stateParams;

            if (hUser.isTopLevelContext() && !brand_id) {
                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
            }

            const isEVerifyServiceEnabled = brand_id ?
                brandServices.check(brandServices.SERVICES.E_VERIFY, brand_id, true) :
                hUser.isEVerifyServiceEnabled();

            if (!isEVerifyServiceEnabled) {
                $state.go("appLayout.harriSH.dashboard");
            }
        }],
        "views": {
            "training": {
                "templateUrl": "../modules/training/e-verify/views/e_verify_test.html",
                "controller": "EVerifyTestController",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["e_verify_training"]
        }

    },
    "/offer/:doc_id": {
        "enableUTM": true,
        "name": "candidate_offer",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["candidate_offer"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            }, {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/on-boarding/candidate-sign/candidate-sign.module.js");
                }
            },
        ],
        "templateUrl": "../modules/offer/views/offer.html",
        "controller": "OfferController"
    },
    "/tl-offer/:doc_id": {
        "enableUTM": true,
        "name": "appLayout.schedule.candidate_offer",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["candidate_offer"]
        },
        "views": {
            "body": {
                templateUrl: "../modules/offer/views/offer.html",
                controller: "OfferController"
            }
        }
    },"/screening/:brand_id/application?job_id&application_id&screening_forms_id&form_type": {
        "enableUTM": true,
        "loginRequired": true,
        "name": "BulkApplyScreening",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["candidate_screening"]
        },
        "templateUrl": "../modules/screening/views/candidate_screening.html",
        "controller": "ScreeningController",
        'route_dependencies': [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ]
    },
    "/wotc/bulk-screening/{brand_id:[0-9]*}?jobId&app_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            jobId: {dynamic: true},
            app_id: {dynamic: true},
        },
        "name": "BulkApplyScreening.wotc",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wotc", "candidate_screening"]
        },
        "views": {
            "wotc-application": {
                "component": "wotcContainerComponent",
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            }
        ]
    },
    "/screening/:brand_id/:job_id/application/:application_id/:screening_forms_id?form_type": {
        "enableUTM": true,
        "loginRequired": true,
        "name": "screening",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["candidate_screening"]
        },
        "templateUrl": "../modules/screening/views/candidate_screening.html",
        "controller": "ScreeningController",
        'route_dependencies': [
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ]
    },
    "/wotc/screening/{brand_id:[0-9]*}?jobId&app_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            jobId: {dynamic: true},
            app_id: {dynamic: true},
        },
        "name": "screening.wotc",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wotc", "candidate_screening"]
        },
        "views": {
            "wotc-application": {
                "component": "wotcContainerComponent",
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            }
        ]
    },
    "/documents/:brand_id/:document_code": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.upload-documents",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["employer_sign_doc"]
        },
        "templateUrl": "../modules/on_boarding/views/employer_sign_document.html",
        "controller": "EmployerSignDocumentsController",
        "params": {data: null},
        "onExit": ['localize', function (localize) {
            HStorageManager.remove({
                key: 'employer_sign_document_controller_data',
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
            })
            localize.enableLocale();
        }],
        "onEnter": ['localize', function (localize) {
            $('body').removeClass('modal-open');
            localize.disableLocale();
        }]
    },
    "/switch?fromId&toId&fromState&toState&fromParams&toParams": {
        "loginRequired": true,
        "name": "teamlive_switch",
        "type": "frontend",
        "controller": ["$state", "$stateParams", "TeamScheduleService", "hUser", function ($state, $stateParams, TeamScheduleService, hUser) {
            var state1 = {
                brandId: parseInt($stateParams.fromId),
                name: $stateParams.fromState,
                params: JSON.parse($stateParams.fromParams)
            };

            var state2 = {
                brandId: parseInt($stateParams.toId),
                name: $stateParams.toState,
                params: JSON.parse($stateParams.toParams)
            };

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var targetState = state2;

                    if (targetState.brandId === brand.id && state1.brandId) {
                        targetState = state1;
                    }

                    var redirect = function(){
                        TeamScheduleService.setActiveBrand({id: targetState.brandId}, true);
                        console.warn("Redirecting to:", targetState);
                        $state.go(targetState.name, targetState.params);
                    }

                    if (targetState.params.parentId) {
                        hUser.setUserContext({
                            brand_id: parseInt(targetState.params.parentId),
                            brand_type: 'enterprise'
                        });
                        TeamScheduleService.resetBrands();
                        TeamScheduleService.getBrands().then(function () {
                            redirect();
                        })
                    } else {
                        redirect()
                    }
                });
        }]
    },
    "/par-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.par-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                templateUrl: "../modules/team_schedule/employer/par-labor/par-labor.html",
                controller: "ParLaborController",
                controllerAs: "ParLaborController"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": ['hUser', function (hUser) {
            if (!hUser.hasSalesAccess()) {
                hRedirect('/dashboard');
            }
        }],
    },
    "/manage-par-labor/:week/:forecast_id": {
        "loginRequired": true,
        "name": "appLayout.schedule.manage-par-labor",
        "showGlobalSearch": true,
        "params": {week: "", forecast_id: ""},
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../modules/team_schedule/employer/manage-par-labor/manage-par-labor.html",
                controller: "ManageParLaborController",
                controllerAs: "manageParLaborController"
            }
        },
        "onEnter": ['hUser', function (hUser) {
            if (!hUser.hasSalesAccess()) {
                hRedirect('/dashboard');
            }
        }],
    },
    "/view-employee-schedule/:brand_id/:employee_id?date": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "reloadOnSearch": false,
        "name": "appLayout.schedule.view-employee-schedule",
        "type": "frontend",
        "views": {
            "body": {
                templateUrl: "../modules/team_schedule/employer/schedule/views/ts_view_employee_schedule.html",
                controller: "TSViewEmployeeScheduleController"
            }
        }
    },
    "/driveretention": {
        "name": "calculator",
        "type": "backend-frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "controller": 'CalculatorController',
        "templateUrl": "../modules/calculator/views/calculator.html",
    },
    "/costsaving": {
        "name": "costsaving",
        "type": "backend-frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "controller": 'CostSavingController',
        "templateUrl": "../modules/cost-saving/views/cost-saving.html",
    },
    "/aubainecareers": {
        "enableUTM": true,
        "name": "aubainecareers",
        "clearPrevState": true,
        "templateUrl": "../modules/profiles/views/aubainecareers/main.html",
        "type": "backend-frontend",
        "controller": 'PremiumProfileController',
        "onExit": function () {
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Aubaine | Harri"
            },
            {
                "tag": "meta",
                "attributes": {
                    "name": "description",
                    "content": "Aubaine."
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "Aubaine | Harri"}
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "../images/premium_profiles/aubainecareers/roundel-logo.png"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:description",
                    "content": "Aubaine"
                }
            }
        ],
        "resolve": {
            "brandDetails":  function(){
                return {
                    brandId: '1603023',
                    slug: 'aubaine'
                };
            }
        }
    },
    "/magnoliabakerycareers": {
        "enableUTM": true,
        "name": "magnoliabakerycareers",
        "clearPrevState": true,
        "templateUrl": "../modules/profiles/views/magnolia-bakery/main.html",
        "type": "backend-frontend",
        "controller": 'PremiumProfileController',
        "onExit": function () {
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Magnolia jobs & careers | Harri"
            },
            {
                "tag": "meta",
                "attributes": {
                    "name": "description",
                    "content": ""
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "Magnolia jobs & careers | Harri"}
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "../images/premium_profiles/magnolia-bakery/logo-1.jpeg"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:description",
                    "content": ""
                }
            }
        ],
        "resolve": {
            "innder_page": function () {
                return "HOME";
            },
            "brandDetails": function () {
                return {
                    brandId: 1480715,
                    slug: 'Magnolia-Bakery-29'
                };
            }
        }
    },
    "/magnoliabakerycareers/our-people": {
        "enableUTM": true,
        "name": "magnoliabakerycareers-our-people",
        "clearPrevState": true,
        "templateUrl": "../modules/profiles/views/magnolia-bakery/our-people.html",
        "type": "backend-frontend",
        "controller": 'PremiumProfileController',
        "onExit": function () {
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Magnolia jobs & careers | Harri"
            },
            {
                "tag": "meta",
                "attributes": {
                    "name": "description",
                    "content": ""
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "Magnolia jobs & careers | Harri"}
            },
            {
                "tag": "meta",
                // Directly add image url to avoid redirection that causes issues with FB share.
                "attributes": {
                    "property": "og:image",
                    "content": "../images/premium_profiles/magnolia-bakery/logo-1.jpeg"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:description",
                    "content": ""
                }
            }
        ],
        "resolve": {
            "innder_page": function () {
                return "OURPEOPLE";
            },
            "brandDetails": function () {
                return {
                    brandId: 1480715,
                    slug: 'Magnolia-Bakery-29'
                };
            }
        }
    },

    "/global-search-result/:search_phrase" : {
        "enableUTM": true,
        "name": "appLayout.harriSH.globalSearch",
        "type": "frontend",
        "preventTimeTracking": true,
        "reloadOnSearch": false,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "controller": "GlobalSearchResultController",
        "templateUrl": "../modules/global_search_results/global_search_results.html",
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            search_phrase: "",
            results: null,
            hits: null
        }
    },
    "/pobhotels{filters:.*}": {
        "name": "prideOfBritain",
        "type": "backend-frontend",
        "loginRequired": false,
        "showGlobalSearch": true,
        "preventTimeTracking": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "PoB Hotels Vacancies | HARRI"
            },
            {
                "tag": "meta",
                "attributes": {"property": "robots", "content": "noindex"}
            }
        ],
        "resolve": {
            "cardsLoaderCount":  function(){
                return {
                    count: 8,
                };
            }
        },
        "templateUrl": "../modules/search/controllers/custom-job-search/custom-job-search.controller.html",
        "controller": 'customJobSearchController',
        "onEnter": ['$state', 'hUser', function ($state, hUser) {
            hUser.init().then(function () {
                if(hUser.isEmployer()) {
                    if (hUser.isTopLevelContext()) {
                        Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                    } else {
                        $state.go("appLayout.harriSH.dashboard");
                    }
                }
            });
        }],
    },
    "/redirect-to-support?return_to" : {
        "name": "redirect-to-support",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "onEnter": ['$stateParams', function ($stateParams) {
            Utils.redirectToSupport(false,$stateParams.return_to);
        }],
    },
    "/redirect-to-academy": {
        "name": "redirect-to-academy",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "onEnter": ['brandServices', '$q', 'hUser', '$state', function (brandServices, $q, hUser, $state) {
            var fallBackState = 'appLayout.harriSH.dashboard'
            var isHarriAcademyEnabled = false;
            if(hUser.isEmployer() && hUser.isTopLevelContext()) {
                fallBackState = "appLayout.harriSH.access-portal.main";
            }
            brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, hUser.getEntryMode().brand_id)
                .then(function (isActive) {
                    if (isActive) {
                        $q.all({
                            getAcademyLink: UserAPI.getAcademyLink(),
                        })
                            .then(function (res) {
                                if (
                                    res['getAcademyLink'] &&
                                    res['getAcademyLink']['redirection_link']
                                ) {
                                    hRedirect(res['getAcademyLink']['redirection_link']);
                                }
                                else {
                                    Utils.redirectToWorkspace(fallBackState);
                                }
                            })
                            .catch(function (err) {
                                console.error(err && err.data);
                                Utils.redirectToWorkspace(fallBackState);
                            });
                    } else {
                        Utils.redirectToWorkspace(fallBackState);
                    }
                })
        }],
    },
    "/lms-scrom-close" : {
        "enableUTM": true,
        "name": "lms_scrom_close",
        "type": "frontend",
        "preventTimeTracking": true,
        "loginRequired": true,
        "showGlobalSearch": true,
        "onEnter": [function () {
            window.parent.lmsModalService.closeModal()
        }],
    },
    "/lms-scrom?registration_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            registration_id: {dynamic: true}
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "name": "dashboard-member.lms-scrom",
        "type": "frontend",
    },
    "/wotc-close" : {
        "enableUTM": true,
        "name": "wotc_close",
        "type": "frontend",
        "preventTimeTracking": true,
        "loginRequired": true,
        "showGlobalSearch": true,
        "onEnter": [function () {
            window.parent.wotcModalService.closeModal()
        }],
    }
};

//export public configuration to node.js app.
try {
    var wpRoutes = require("../../wp-pages/wp-pages.routes.js");
    publicConfiguration['routes'] = _.extend(publicConfiguration['routes'], wpRoutes);
    module.exports = publicConfiguration['routes'];
} catch (e) {
}
